"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
import { Tooltip } from "react-tooltip";
interface WaveDropActionsOptionsProps {
  readonly drop: ApiDrop;
}
const WaveDropActionsOptions: React.FC<WaveDropActionsOptionsProps> = t0 => {
  const $ = _c(17);
  const {
    drop
  } = t0;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.stopPropagation();
      setIsDeleteModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `delete-${drop.id}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" aria-hidden="true" stroke="currentColor" className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-transition tw-ease-out tw-duration-300"><path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" /></svg>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <button onClick={t1} className="tw-text-iron-500 icon tw-px-2 tw-h-full tw-group tw-bg-transparent tw-rounded-full tw-border-0 tw-flex tw-items-center tw-gap-x-2 tw-text-[0.8125rem] tw-leading-5 tw-font-medium tw-transition tw-ease-out tw-duration-300" aria-label="Delete drop" data-tooltip-id={t2}>{t3}</button>;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `delete-${drop.id}`;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px",
      zIndex: 10
    };
    t7 = <span className="tw-text-xs">Delete</span>;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t5) {
    t8 = <Tooltip id={t5} place="top" style={t6}>{t7}</Tooltip>;
    $[6] = t5;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== drop || $[9] !== isDeleteModalOpen) {
    t9 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[8] = drop;
    $[9] = isDeleteModalOpen;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <CommonAnimationWrapper mode="sync" initial={true}>{t9}</CommonAnimationWrapper>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t8) {
    t11 = <>{t4}{t8}{t10}</>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
export default WaveDropActionsOptions;
function _temp(e_0) {
  return e_0.stopPropagation();
}